<template>
  <div class="app-container">
    <div class="config hidden-print">
      <div class="hts">题目规则</div>
      <form class="form-horizontal">
        <div class="form-group">
          <label class="col-sm-4 control-label">最大数值</label>
          <div class="col-sm-8">
            <input type="number"
                   class="form-control text"
                   placeholder="多少以内的加减法"
                   v-model="currentNum"
                   @blur="blurNum">
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-4 control-label">题目数量</label>
          <div class="col-sm-8">
            <input type="number"
                   class="form-control text"
                   placeholder="要生成多少题"
                   v-model="currentSize"
                   @blur="blurSize">
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-4 control-label">题目类型</label>
          <div class="col-sm-8">
            <a href="#"
               class="btn btn-default btn-sm"
               :class="{'btn-warning':type==0}"
               @click="type=0">加法</a>
            <a href="#"
               class="btn btn-default btn-sm"
               :class="{'btn-warning':type==1}"
               @click="type=1">减法</a>
            <a href="#"
               class="btn btn-default btn-sm"
               :class="{'btn-warning':type==2}"
               @click="type=2">加减法</a>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <a href="javascript:;"
               type="submit"
               class="btn btn-primary btn-block"
               @click="reset">自动生成题目</a>
          </div>
        </div>

        <div class="form-group pad-hidden">
          <div class="col-sm-12">
            <a href="javascript:window.print()"
               type="submit"
               class="btn btn-default btn-block">打印</a>
          </div>
        </div>
        <hr class="pad-hidden">
        <div class="form-group">
          <div class="col-sm-12">
            <a href="javascript:;"
               type="submit"
               class="btn btn-success btn-block"
               @click="getResult">查看做题结果</a>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <div class="copyright">Design By yyt</div>
          </div>
        </div>
        <!-- <div class="form-group">
          <div class="col-sm-12">
            <a href="javascript:;"
               type="submit"
               class="btn btn-default btn-block"
               @click="reTest">重做</a>
          </div>
        </div> -->
      </form>
    </div>
    <div class="page-print">
      <div class="head">
        <h1>{{page.title}}以内的{{page.des}}法</h1>
        <p>{{nowDate}} 题目数量：{{page.size}}</p>
      </div>
      <div class="body">
        <ul>
          <li v-for="(item,index) in list"
              :key="'key'+index">{{item.num1}} {{item.type ? '-' : '+'}} {{item.num2}} =
            <input type="tel"
                   class="result-input"
                   v-model="item.result_test"
                   @focus="is_result=false"
                   :class="{right:is_result && item.result == item.result_test, err: is_result && item.result != item.result_test}">
          </li>
        </ul>
      </div>
    </div>
    <div class="modal fade hidden-print"
         id="resultModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="myModalLabel">
      <div class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button"
                    class="close"
                    aria-label="Close"
                    data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
            <!-- <h4 class="modal-title"
                id="myModalLabel">做题结果</h4> -->
          </div>
          <div class="modal-body">
            <div class="result">
              <div class="ht"
                   v-html="result.score"></div>
              <div class="intro"
                   v-html="result.des"></div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button"
                    class="btn btn-default"
                    data-dismiss="modal">关闭</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style lang="stylus">
.copyright
  padding-top 50px
  color #999
input.right
  color #5cb85c
  border-color #5cb85c
input.err
  color #d9534f
  border-color #d9534f
.result
  text-align center
  .ht
    display flex
    justify-content center
    align-items flex-end
    font-size 24px
    h2
      padding 0
      margin 0
      font-size 48px
      color #4cae4c
      &.c1
        color #d9534f
      &.c2
        color #f0ad4e
      &.c3
        color #4cae4c
  .intro
    font-size 18px
.modal-header, .modal-footer
  border 0
  text-align center
.result-input
  border 0
  border-bottom 1px solid #333
  width 30px
  font-weight bold
.config
  position fixed
  background rgba(0, 0, 0, 0.75)
  left 0
  top 0
  bottom 0
  width 320px
  color #fff
  padding 20px
  hr
    border-color rgba(255, 255, 255, 0.15)
  .btn-sm
    background none
    color #fff
    &.btn-warning
      color #eea236
  .hts
    font-size 24px
    font-weight bold
    padding-bottom 15px
  .form-control.text
    &::-webkit-input-placeholder
      color transparent
      transition all 0.2s
      color #666
    &:focus
      box-shadow none
      border-color #ff6700
      outline none
    &:focus::-webkit-input-placeholder
      color #999
      transition all 0.2s
    background none
    outline none
    border 0
    border-bottom 1px solid rgba(255, 255, 255, 0.15)
    border-radius 0
    color #fff
    font-weight bold
    transition all 0.2s
.page-print
  width 794px
  min-height 1123px
  padding 20px 30px
  margin 30px auto
  background-color #fff
  box-shadow 0 1px 3px rgba(0, 0, 0, 0.1)
  page-break-before always
  .head
    text-align center
    h1
      font-size 30px
      padding 20px 0 0
    p
      font-size 16px
      padding-bottom 20px
  .body
    padding 0 0 0 90px
    font-size 24px
    ul
      list-style none
      padding 0
      display flex
      flex-wrap wrap
      li
        width 33.333%
        padding-bottom 24px
        font-weight normal
@media print
  .page-print
    margin 0
    padding 0
    height 1123px
    overflow hidden
    .body
      padding 0 0 0 90px
      font-size 18px
      ul
        list-style none
        padding 0
        display flex
        flex-wrap wrap
        li
          width 25%
          padding-bottom 13px
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape)
  .pad-hidden
    display none
  .app-container
    display flex
    height 100vh
    .config
      position relative
      flex-shrink 0
    .page-print
      width 100%
      margin 0
      min-height 100%
      height 100%
      overflow scroll
      -webkit-overflow-scrolling touch
      .body
        padding-left 40px
        .result-input
          -webkit-appearance none
          border-radius 0
          width 60px
          font-weight normal
          padding 0
</style>

<script>

export default {
  data () {
    return {
      maxNum: 10,
      maxSize: 100,
      currentNum: 10,
      currentSize: 20,
      type: 0,
      list: [],
      nowDate: '',
      is_result: false,
      result: { score: '', des: '' },
      result_right: 0,
      page: {
        title: 0,
        size: 0,
        des: '加'
      }
    }
  },
  computed: {
    currentName () {
      let name = '加'
      if (this.type === 1) {
        name = '减'
      }
      if (this.type === 2) {
        name = '加减'
      }
      return name
    }
  },
  methods: {
    // 重做
    reTest () {
      this.is_result = false
      this.list.map(v => { v.result_test = '' })
    },
    // 获取做题结果
    getResult () {
      // 设置做对了题数
      this.result_right = 0
      this.list.map(v => {
        if (v.result === parseInt(v.result_test)) {
          this.result_right += 1
        }
      })
      // 设置做题分数，转化成百分制
      const result = parseInt(100 * this.result_right / this.currentSize)
      // 设置分数颜色 60分以下红色，60-85分橙色，85分以上绿色
      let classs = 'c1'
      if (result < 85 && result >= 60) {
        classs = 'c2'
      }
      if (result >= 85) {
        classs = 'c3'
      }
      this.is_result = true
      this.result = {
        score: `<h2 class=${classs}>${result}</h2><span>分</span>`,
        des: `共${this.currentSize}题，正确${this.result_right}题，错误${this.currentSize - this.result_right}题`
      }
      $('#resultModal').modal({ backdrop: 'static', keyboard: false }) // eslint-disable-line
    },
    // 设置计算数值的边界
    blurNum () {
      if (this.currentNum < 10) {
        alert('太简单啦～')
        this.currentNum = 10
      }
      if (this.currentNum <= 15 && this.currentSize > 40) {
        this.currentSize = 40
      }
    },
    // 设置题目最大及最小边界
    blurSize () {
      if (this.currentSize < 10) {
        alert('题目太少了，这都不够看～')
        this.currentSize = 10
      } else if (this.currentSize > 100) {
        alert('题目太多了，要累死朕啊～')
        this.currentSize = 100
      }
      if (this.currentNum <= 15 && this.currentSize > 40) {
        this.currentSize = 40
      }
    },
    // 重新生成题目
    reset () {
      this.is_result = false
      this.list = []
      this.blurSize()
      this.page = {
        title: this.currentNum,
        size: this.currentSize,
        des: this.currentName
      }
      this.addList()
    },
    // 添加题目
    addList () {
      const size = this.list.length
      // 如果题目长度小于设置题目数量
      if (size < this.currentSize) {
        this.addNumber(size + 1)
        this.addList()
      }
    },
    // 添加一题
    addNumber (size) {
      // 生成2个小于设置数字的随机数
      let a = parseInt(this.currentNum * Math.random()) + 1
      let b = parseInt(this.currentNum * Math.random()) + 1
      let reduce = ''
      // 判断类型，获取相应题目设置
      if (this.type === 0) {
        reduce = this.add(a, b)
      }
      if (this.type === 1) {
        reduce = this.subtraction(a, b)
      }
      if (this.type === 2) {
        const arr = [0, 1]
        const type = arr[Math.floor(Math.random() * arr.length)]
        reduce = type ? this.subtraction(a, b) : this.add(a, b)
      }
      // 如果题目有效，将不重复的题目添加的列表
      if (reduce) {
        let isInclude = this.list.some(v => {
          const { num1, num2, type } = reduce
          return v.num1 === num1 && v.num2 === num2 && v.type === type
        })
        if (!isInclude) {
          this.list.push(reduce)
        }
      }
    },
    // 加法
    add (a, b) {
      let reduce = ''
      if (a + b <= this.currentNum) {
        reduce = {
          num1: a,
          num2: b,
          type: 0,
          result: a + b,
          result_test: ''
        }
      }
      return reduce
    },
    //  减法
    subtraction (c, d) {
      let a = c > d ? c : d
      let b = c > d ? d : c
      return {
        num1: a,
        num2: b,
        type: 1,
        result: a - b,
        result_test: ''
      }
    }
  },
  mounted () {
    this.nowDate = this.$moment().format('YYYY年MM月DD日 dddd')
    this.page.title = this.currentNum
    this.page.size = this.currentSize
    this.addList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue